"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRouter = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
let globalNavigation = null;
const listeners = [];
const trackNavigationChange = (location) => {
    listeners.forEach((listener) => {
        listener(location);
    });
};
const Spy = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    React.useEffect(() => {
        globalNavigation = navigate;
        trackNavigationChange(location);
    }, []);
    React.useEffect(() => {
        trackNavigationChange(location);
    }, [location]);
    return null;
};
const withRouter = (Component) => (props) => {
    const location = (0, react_router_dom_1.useLocation)();
    const params = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    return (React.createElement(Component, Object.assign({}, props, { location: location, navigate: navigate, params: params })));
};
exports.withRouter = withRouter;
const NavigationService = {
    addListener: (listener) => listeners.push(listener),
    getCurrentPathname: () => {
        if (window && window.location) {
            return window.location.pathname || null;
        }
        return null;
    },
    getSearchParams: () => {
        if (window && window.location) {
            return new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
        }
        return {};
    },
    redirect: (params) => {
        if (globalNavigation !== null) {
            const { pathname, search, state, } = params;
            let path = pathname;
            if (search) {
                path = {
                    pathname,
                    search: (0, react_router_dom_1.createSearchParams)(search).toString(),
                };
            }
            globalNavigation(path, {
                state,
            });
        }
        return params;
    },
    render: Spy,
    replace: (params) => {
        if (window && window.history) {
            window.history.replaceState(null, '', params.pathname);
        }
        return params;
    },
};
exports.default = NavigationService;
